import { render, staticRenderFns } from "./MailboxPicker.vue?vue&type=template&id=e5e88a1a"
import script from "./MailboxPicker.vue?vue&type=script&lang=js"
export * from "./MailboxPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports